import type { GetServerSidePropsContext, NextPage } from 'next';

import { WebAppApiService } from 'services';

import { PagesType } from 'common/pages-type';

import Layout from '@/components/layout/layout';

import { IWebAppModel } from 'models';

import styles from './mentions.module.scss';
import { useEffect } from 'react';
import { MixpanelTrackingService } from '@/services/mixpanel-services';

interface IMentionsPageProps {
  webApp: IWebAppModel;
  preview: boolean;
}

const MentionsPage: NextPage<IMentionsPageProps> = ({ webApp, preview }) => {
  useEffect(() => {
    MixpanelTrackingService.getInstance().pageViewed();
  }, []);

  return (
    <Layout
      preview={preview}
      origin={PagesType.Mentions}
      headerImageUrl={webApp.headerImageUrl}
      logoUrl={webApp.logoUrl}
      stravaUrl={webApp.stravaUrl}
      facebookUrl={webApp.facebookUrl}
      instagramUrl={webApp.instagramUrl}
      title="Mentions légales"
      description="Mentions légales"
      slogan={webApp.description}>
      <div className={styles.container}>
        <h1 className={styles.title}>Mentions légales</h1>
      </div>
    </Layout>
  );
};

export const getServerSideProps = async (
  context: GetServerSidePropsContext,
) => {
  try {
    const webAppService = new WebAppApiService();
    const webapp = await webAppService.getWebApp(context);

    return {
      props: {
        webApp: webapp,
        preview: context.preview ?? false,
      } as IMentionsPageProps,
    };
  } catch {
    return {
      props: {},
    };
  }
};

export default MentionsPage;
